// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"LoaderPage_loader_wrapper__ky4NK","loader":"LoaderPage_loader__IGmC5","l5":"LoaderPage_l5__sAfQ9"};